import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-container w-full h-full" }
const _hoisted_2 = { class: "col w-full h-full" }
const _hoisted_3 = { class: "component-header w-full" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "component-section w-full h-full modal-content-transparent" }
const _hoisted_7 = {
  key: 0,
  class: "component-active w-full height-scroll"
}
const _hoisted_8 = {
  key: 1,
  class: "component-active w-full height-scroll"
}
const _hoisted_9 = {
  key: 2,
  class: "component-active w-full height-scroll"
}
const _hoisted_10 = {
  key: 3,
  class: "component-active w-full height-scroll"
}
const _hoisted_11 = {
  key: 4,
  class: "component-active w-full height-scroll"
}
const _hoisted_12 = {
  key: 5,
  class: "component-active w-full height-scroll"
}
const _hoisted_13 = {
  key: 6,
  class: "component-active w-full height-scroll"
}
const _hoisted_14 = {
  key: 7,
  class: "component-active w-full height-scroll"
}
const _hoisted_15 = {
  key: 8,
  class: "component-active w-full height-scroll"
}
const _hoisted_16 = { class: "component-footer w-full row-end" }

import { ref, watch, computed } from 'vue';
import { useI18n } from "vue-i18n";
import EsMySettingsSettings from '@/views/officeMain/settings/esMySettingsSettings.vue';
import DashbInstituteSettings from '@/views/officeMain/settings/dashbInstituteSettings.vue';
import esAccountSettings from '@/views/officeMain/settings/esAccountSettings.vue';
import esTaskSettings from '@/views/officeMain/settings/esTaskSettings.vue';
import EsPatientSettings from '@/views/officeMain/settings/esPatientSettings.vue';
import EsBillingSettings from '@/views/officeMain/settings/esBillingSettings.vue';
import esAgendaSettings from '@/views/officeMain/settings/esAgendaSettings.vue';
import EsPermissionSetting from '@/views/officeMain/settings/esPermissionSetting.vue';
import { usePermissionsStore } from '@/stores/permissionsStore';
import { Permissions } from '@/models/permissions.model';
import { SettingMenuEnum } from '@/models/subMenu.model';
import EsSubMenu from '@/components/share/esSubMenu.vue';
import { useAppUserStore } from '@/stores/appUser';
import { PersonWithRoleStatus } from '@/models/share.model';
import EsNotificationSettings from '@/views/officeMain/settings/esNotificationSettings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbSettings',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["modal-close", "refresh-calendar", "refresh-health-pro"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const permissionStore = usePermissionsStore();
const appUserStore = useAppUserStore();

const emits = __emit;
const target = ref(null);
const itemSelected = ref<SettingMenuEnum>(SettingMenuEnum.HOME);
const title = ref<string>(t('settings.params.title'));
const subtitle = ref<string>(t('settings.params.preferences.subTitle'));
const permissionInstitute = ref<boolean>(false);
const permissionAgenda = ref<boolean>(false);
const permissionOwnerAgenda = ref<boolean>(false);
const isHealthPro = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return PersonWithRoleStatus.HealthPro === appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personRoleType
});

const menuItems = computed(()=> [
    {
        ref: SettingMenuEnum.HOME,
        label: t('settings.params.preferences.title'),
        icon: 'slider-horizontal-3',
        pathIcon: 'settings',
        displaySeparator: true,
        visible: true,
        command: () => {
          subtitle.value = t('settings.params.preferences.subTitle');
          itemSelected.value = SettingMenuEnum.HOME;
        }
    },
    {
        ref: SettingMenuEnum.ACCOUNT,
        label: t('settings.params.account.title'),
        icon: 'id-card',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: true,
        command: () => {
          subtitle.value = t('settings.params.account.subTitle');
          itemSelected.value = SettingMenuEnum.ACCOUNT;
        }
    },
    {
        ref: SettingMenuEnum.INSTITUTE,
        label: t('settings.params.institute.title'),
        icon: 'building-2',
        pathIcon: 'settings',
        displaySeparator: true,
        visible: permissionInstitute.value,
        command: () => {
          subtitle.value = t('settings.params.institute.subTitle');
          itemSelected.value = SettingMenuEnum.INSTITUTE;
        }
    },
    {
        ref: SettingMenuEnum.PATIENT,
        label: t('settings.params.patient.title'),
        icon: 'person-2',
        pathIcon: 'settings',
        displaySeparator: true,
        visible: isHealthPro.value,
        command: () => {
          subtitle.value = t('settings.params.patient.subTitle');
          itemSelected.value = SettingMenuEnum.PATIENT;
        }
    },
    {
        ref: SettingMenuEnum.AGENDA,
        label: t('settings.params.calendar.title'),
        icon: 'calendar',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: permissionAgenda.value,
        command: () => {
          subtitle.value = t('settings.params.calendar.subTitle');
          itemSelected.value = SettingMenuEnum.AGENDA;
        }
    },
    {
        ref: SettingMenuEnum.TASK,
        label: t('settings.params.tasks.title'),
        icon: 'bubble-checkmark',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: true,
        command: () => {
          subtitle.value = t('settings.params.tasks.subTitle');
          itemSelected.value = SettingMenuEnum.TASK;
        }
    },
    {
        ref: SettingMenuEnum.BILLING,
        label: t('settings.params.billing.title'),
        icon: 'creditcard',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: true,
        command: () => {
          subtitle.value = t('settings.params.billing.subTitle');
          itemSelected.value = SettingMenuEnum.BILLING;
        }
    },
    {
        ref: SettingMenuEnum.PERMISSION,
        label: t('settings.params.permission.title'),
        icon: 'lock',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: permissionInstitute.value,
        command: () => {
          subtitle.value = t('settings.params.permission.subTitle');
          itemSelected.value = SettingMenuEnum.PERMISSION;
        }
    },
    {
        ref: SettingMenuEnum.NOTIFICATION,
        label: t('settings.params.notification.title'),
        icon: 'bell',
        pathIcon: 'settings',
        displaySeparator: false,
        visible: permissionInstitute.value,
        command: () => {
          subtitle.value = t('settings.params.notification.subTitle');
          itemSelected.value = SettingMenuEnum.NOTIFICATION;
        }
    }
]);

const refreshHealthPro = async (permissionOwnerAgendaValue: boolean) => {
  permissionOwnerAgenda.value = permissionOwnerAgendaValue;
  emits('refresh-health-pro');
}

watch(
  () => props.isOpen,
  async (newVal) => {
    if (newVal === true) {
      permissionInstitute.value = await permissionStore.checkPermission(Permissions.admin.ADMIN_INSTITUTE.name);
      permissionAgenda.value = await permissionStore.checkPermission(Permissions.planning.ACCESS_PLANNING.name);
      permissionOwnerAgenda.value = await permissionStore.checkPermission(Permissions.planning.OWNER_PLANNING.name);
    }
  }
);

const closeFormModal = () => {
  emits("modal-close");
};

return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "h-full w-full modal-wrapper modal-mask",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (closeFormModal()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "row es-tab-settings content h-95p",
            ref_key: "target",
            ref: target,
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(EsSubMenu, {
              "item-selected": itemSelected.value,
              items: menuItems.value,
              "path-icon": 'adminIcons',
              class: "h-full"
            }, null, 8, ["item-selected", "items"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(title.value), 1),
                _createElementVNode("h2", _hoisted_5, _toDisplayString(subtitle.value), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (itemSelected.value === _unref(SettingMenuEnum).HOME)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(EsMySettingsSettings)
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).ACCOUNT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(esAccountSettings, { class: "w-full" })
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).INSTITUTE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(DashbInstituteSettings, {
                        class: "w-full",
                        onRefreshCalendar: _cache[0] || (_cache[0] = ($event: any) => {_unref(appUserStore).setRefreshCalendar($event);})
                      })
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).PATIENT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(EsPatientSettings)
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).AGENDA)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(esAgendaSettings, {
                        onRefreshCalendar: _cache[1] || (_cache[1] = ($event: any) => {_unref(appUserStore).setRefreshCalendar($event);}),
                        hasOwnerAgendaPermission: permissionOwnerAgenda.value
                      }, null, 8, ["hasOwnerAgendaPermission"])
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).TASK)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(esTaskSettings)
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).BILLING)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(EsBillingSettings, { class: "w-full" })
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).PERMISSION)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(EsPermissionSetting, {
                        class: "w-full",
                        onRefreshHealthPro: _cache[2] || (_cache[2] = ($event: any) => (refreshHealthPro($event)))
                      })
                    ]))
                  : _createCommentVNode("", true),
                (itemSelected.value === _unref(SettingMenuEnum).NOTIFICATION)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(EsNotificationSettings, { class: "w-full" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_es_button, {
                  class: "action-button",
                  "is-primary": false,
                  label: _unref(t)('action.close'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (closeFormModal()))
                }, null, 8, ["label"])
              ])
            ])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})